import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import type { SectionsVariantsType } from "./Sections";

// STYLES
const main = css`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-5);

    @media screen and (min-width: ${breakpoints.xl}) {
        row-gap: var(--spacing-7);
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-7);
        }
    }
`;

// COMPONENTS
export const SectionsVariants = {
    main,
};

const SectionsVariant = styled.div<{ variant: SectionsVariantsType }>`
    ${(props) =>
        props.variant &&
        css`
            ${SectionsVariants[props.variant]}
        `};
`;

export default SectionsVariant;
